var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6997 9.95489V7.85858C16.6697 5.40148 14.6527 3.43499 12.1957 3.46519C9.78974 3.49549 7.84273 5.43368 7.80273 7.83908V9.95489M15.75 21.5206C17.345 21.5206 17.3387 21.5206 17.9547 21.2249C18.5687 20.9298 19.0647 20.434 19.3597 19.8193C19.6557 19.2036 19.6558 18.4059 19.6558 16.8106V14.6787C19.6558 13.0834 19.6557 12.2858 19.3597 11.6702C19.0647 11.0554 18.5687 10.5596 17.9547 10.2643C17.3387 9.96875 16.5407 9.96875 14.9457 9.96875H9.55371C7.95871 9.96875 7.16074 9.96875 6.54474 10.2643C5.93074 10.5596 5.43477 11.0554 5.13977 11.6702C4.84377 12.2858 4.84375 13.0834 4.84375 14.6787V16.8106C4.84375 18.4059 4.84377 19.2036 5.13977 19.8193C5.43477 20.434 5.93074 20.9298 6.54474 21.2249C7.16074 21.5206 7.95871 21.5206 9.55371 21.5206H12.2497M13.8945 15.6876C13.8945 16.5958 13.1585 17.3322 12.2495 17.3322C11.3415 17.3322 10.6055 16.5958 10.6055 15.6876C10.6055 14.7795 11.3415 14.043 12.2495 14.043C13.1585 14.043 13.8945 14.7795 13.8945 15.6876Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLock);
export default __webpack_public_path__ + "static/media/whiteLock.90d6e8bbdc37cd812fefc1d1955a2c1c.svg";
export { ForwardRef as ReactComponent };